import {
	ApiClient,
	AsyncResult,
	FileDownloadGetApiRequestBody,
	FileDownloadGetApiResponse,
} from "@jace/api";

export async function getDownloadUrl(
	uri: string,
	transport: ApiClient,
): AsyncResult<FileDownloadGetApiResponse> {
	return transport.get<FileDownloadGetApiResponse>("/files/download", {
		query: {
			unified_uri_str: uri,
		},
	} satisfies FileDownloadGetApiRequestBody);
}
